import { useEffect, useState } from 'react';
import { studioApi } from '@/lib/studioApi';

let request = null;
export const fetchLaunch = () => (request ||= studioApi('/launch').catch(() => { request = null; return null; }));
export const useLaunch = () => {
  const [info, setInfo] = useState(null);
  useEffect(() => { fetchLaunch().then(setInfo); }, []);
  return info;
};
export const openLaunchNotice = () => window.dispatchEvent(new Event('shop-closed'));
export const shopClosed = async () => { const s = await fetchLaunch(); return !!s && !s.open; };
